import React from 'react';
import { LiveChatContextProvider } from './LiveChat';

const Stores = ({ children }) => {
  return <LiveChatContextProvider>{children}</LiveChatContextProvider>;
};

export default Stores;
